// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // Add this import
import App from './App';
// styles.css already imported in App.js
import { ThemeProvider } from './ThemeContext';

// Create a root for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app inside the root with proper provider hierarchy
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
